import { pages } from './pages';
import { ModuleType } from './types';

export const commonModule: ModuleType = {
	pages,
};
